module.exports = __webpack_public_path__ + "static/img/kongzhuangt.7c2ba51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kongzhuangt.svg
// module id = WQOp
// module chunks = 19